module.exports = __webpack_public_path__ + "static/media/AppointmentIcon.99236927.svg";